import * as React from 'react';

import { cn } from '@heidi/utils';

import { badgeVariants } from './badge.styles';
import type { BadgeProps } from './badge.types';

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  ({ className, color, size, ...props }, ref) => (
    <div
      data-slot="badge"
      ref={ref}
      className={cn(badgeVariants({ color, size }), className)}
      {...props}
    />
  )
);
Badge.displayName = 'Badge';

export { Badge };
